import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Loader from 'react-loader';
import { Container, Button } from 'reactstrap';
import Layout from '../components/Layout';
import PageNav from '../components/PageNav';
import { fetchInformations } from '../modules/InformationList/actions';
import { isLoaded, getError } from '../modules/InformationList/reducer';
import InformationList from '../modules/InformationList';

class InformationListpage extends Component {
  componentDidMount() {
    this.props.fetchInformations();
  }

  render() {
    const { isLoaded } = this.props;
    return (
      <Layout>
        <Container>
          <PageNav>
            <h1>Užitečné informace</h1>
            <Button tag={Link} to="/informace/new" color="primary">
              Nová informace
            </Button>
          </PageNav>
          <Loader loaded={isLoaded}>
            <InformationList />
          </Loader>
        </Container>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    isLoaded: isLoaded(state),
    error: getError(state)
  };
};

export default connect(
  mapStateToProps,
  { fetchInformations }
)(InformationListpage);



// WEBPACK FOOTER //
// ./src/pages/InformationListPage.js